/**
 * Safety Events Bridge
 *
 * Re-exports safety analytics events from the workspace-level lib.
 * This allows using @/lib/analytics/events/safety imports within apps/expo.
 *
 * @see lib/analytics/events/safety.ts at workspace root for event definitions
 */

// Re-export all safety event types and constants
export * from '../../../../../lib/analytics/events/safety';
